// import React, { useEffect } from "react";
// import socket from "../socket";
// import API from "../api";

// export default function ChatWindow({ messages, scId, cuId }) {
//   // useEffect(() => {
//   //   if (messages.length > 0) {
//   //     const lastMsgIds = messages
//   //       .filter((m) =>
//   //         cuId ? m.sender_id !== cuId : m.sender_id !== scId
//   //       )
//   //       .map((m) => m.id);

//   //     if (lastMsgIds.length > 0) {
//   //       socket.emit("read_messages", {
//   //         user_id: cuId || scId,
//   //         message_ids: lastMsgIds,
//   //       });

//   //       API.post("/messages/messages/read", {
//   //         user_id: cuId || scId,
//   //         message_ids: lastMsgIds,
//   //       });
//   //     }
//   //   }
//   // }, [messages, scId, cuId]);

//   return (
//     <div className="flex-1 overflow-y-auto bg-white p-16">
//       {messages.map((m) => (
//         <div
//           key={m.id}
//           className={`mb-2 ${
//             scId === m.sender_id || cuId === m.sender_id
//               ? "text-right"
//               : "text-left"
//           }`}
//         >
//           <div className="inline-block px-3 py-2 rounded bg-gray-100">
//             <div>{m.content}</div>
//             <div className="text-xs text-gray-500">
//               {m.read
//                 ? m.read_at
//                   ? "✓✓ (blue)" // read
//                   : "✓✓" // delivered
//                 : "✓"} {/* sent */}
//             </div>
//           </div>
//         </div>
//       ))}
//     </div>
//   );
// }

import React, { useCallback, useState } from 'react';
import {
  Box,
  Paper,
  Typography,
  Avatar,
  Stack,
  IconButton,
  CircularProgress,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import { IoSearchCircleOutline } from 'react-icons/io5';
import {
  compact,
  includes,
  isEmpty,
  map,
  startsWith,
  uniq,
  uniqBy,
} from 'lodash';
import { useEffect, useRef } from 'react';
import moment from 'moment';
import { BsCheck, BsCheckAll } from 'react-icons/bs';
import { ImageModal } from '../pages/supervisor/SupervisorForm';
import { MdLogout } from 'react-icons/md';
import imageCompression from 'browser-image-compression';

const ChatWindow = ({
  messages,
  scId,
  cuId,
  selectedClients,
  selectedUser,
  isAmbulanceTracker = false,
  loadingMessages = false,
}) => {
  const messagesEndRef = useRef(null);
  const [showImageModal, setShowImageModal] = useState(false);
  const [imageURl, setImageUrl] = useState('');
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  // Scroll to bottom whenever messages change
  useEffect(() => {
    messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' });
  }, [messages]);

  const handleLogout = useCallback(() => {
    localStorage.clear();
    window.location.href = '/login';
  }, []);

  return (
    // <Box sx={{ display: 'flex', flexDirection: 'column', height: '92vh' }}>
    //   {/* Header */}
    //   <Box
    //     sx={{
    //       display: 'flex',
    //       alignItems: 'center',
    //       justifyContent: 'space-between',
    //       p: 2,
    //       borderBottom: '1px solid #ddd',
    //       backgroundColor: '#f0f0f0',
    //       flexShrink: 0,
    //       position: 'sticky',
    //       top: 0,
    //       zIndex: 10,
    //     }}
    //   >
    //     <Typography variant='h6' sx={{ fontWeight: 500 }}>
    //       {selectedUser || 'User Name'}
    //     </Typography>
    //   </Box>

    //   {/* Messages */}
    //   <Box
    //     sx={{
    //       flex: 1,
    //       overflowY: 'auto',
    //       backgroundColor: '#ECE5DD',
    //       p: 2,
    //       display: 'flex',
    //       flexDirection: 'column',
    //     }}
    //   >
    //     {uniq(
    //       messages.filter((msg) => msg?.message_id || msg?.id).filter(Boolean)
    //     ).map((m) => {
    //       const isSender = scId === m.sender_id || cuId === m.sender_id;

    //       return (
    //         <Stack
    //           key={m.id || m?.message_id}
    //           direction={isSender ? 'row-reverse' : 'row'}
    //           spacing={1}
    //           sx={{ mb: 1.5, alignItems: 'flex-end' }}
    //         >
    //           <Avatar
    //             sx={{
    //               bgcolor: 'grey.500',
    //               width: 32,
    //               height: 32,
    //               fontSize: 14,
    //             }}
    //           >
    //             {m.msg_sender ? m.msg_sender[0].toUpperCase() : 'U'}
    //           </Avatar>

    //           <Paper
    //             elevation={1}
    //             sx={{
    //               px: 1.5,
    //               py: 1,
    //               maxWidth: '75%',
    //               backgroundColor: isSender ? '#DCF8C6' : '#FFFFFF',
    //               borderRadius: 3,
    //               display: 'flex',
    //               justifyContent: 'space-between',
    //               gap: 1,
    //             }}
    //           >
    //             <Typography
    //               variant='body1'
    //               sx={{ whiteSpace: 'pre-line', fontSize: '0.8rem' }}
    //             >
    //               {m.content}
    //             </Typography>

    //             <Stack
    //               direction='row'
    //               justifyContent='flex-end'
    //               spacing={0.5}
    //               sx={{ mt: 0.3 }}
    //             >
    //               <Typography
    //                 variant='caption'
    //                 sx={{
    //                   color: 'text.secondary',
    //                   fontSize: '0.7rem',
    //                   display: 'flex',
    //                   alignItems: 'center',
    //                 }}
    //               >
    //                 {m.created_at
    //                   ? moment(m?.created_at)?.format('h:mm A')
    //                   : ''}
    //               </Typography>

    //               {isSender && (
    //                 <Box
    //                   sx={{ ml: 0.5, display: 'flex', alignItems: 'center' }}
    //                 >
    //                   {m.read_at ? (
    //                     <BsCheckAll color='#34B7F1' />
    //                   ) : (
    //                     <BsCheck color='gray' />
    //                   )}
    //                 </Box>
    //               )}
    //             </Stack>
    //           </Paper>
    //         </Stack>
    //       );
    //     })}

    //     {/* Dummy div to scroll into view */}
    //     <div ref={messagesEndRef} />
    //   </Box>
    // </Box>

    <Box sx={{ display: 'flex', flexDirection: 'column', height: '89vh' }}>
      {/* Header */}
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          p: 1.5,
          borderBottom: '1px solid #ddd',
          backgroundColor: '#f0f0f0',
          flexShrink: 0,
          position: 'sticky',
          top: 0,
          zIndex: 10,
        }}
      >
        <Box sx={{ display: 'flex', gap: 1.8, alignItems: 'center' }}>
          <Avatar
            sx={{
              bgcolor: 'grey.500',
              width: 32,
              height: 32,
              fontSize: 14,
            }}
          >
            {selectedUser ? selectedUser[0].toUpperCase() : 'C'}
          </Avatar>
          <Typography variant='h6' sx={{ fontWeight: 500, fontSize: '0.9rem' }}>
            {selectedUser || 'User Name'}
          </Typography>
        </Box>

        {isAmbulanceTracker && (
          <MdLogout size={24} className='logout-icon' onClick={handleLogout} />
        )}
      </Box>

      {loadingMessages ? (
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            flex: 1,
          }}
        >
          <CircularProgress />
        </Box>
      ) : (
        <Box
          sx={{
            flex: 1,
            overflowY: 'auto',
            backgroundColor: '#ECE5DD',
            p: 2,
            display: 'flex',
            flexDirection: 'column',
            mb: isMobile ? 5 : 0,
          }}
        >
          {uniqBy(
            messages
              ?.filter((msg) =>
                !isAmbulanceTracker
                  ? includes(map(selectedClients, 'id'), msg?.sender_id) ||
                    msg?.sender_id ===
                      parseInt(localStorage?.getItem('user_id'))
                  : msg?.id || msg?.message_id
              )
              .filter(Boolean),
            'id'
          )?.map((m) => {
            const isSender = scId === m.sender_id || cuId === m.sender_id;

            // console.log('isSender', isSender, scId,uniqBy(
            //   messages
            //     ?.filter((msg) =>
            //       !isAmbulanceTracker
            //         ? includes(map(selectedClients, 'id'), msg?.sender_id) ||
            //           msg?.sender_id ===
            //             parseInt(localStorage?.getItem('user_id'))
            //         : msg?.id || msg?.message_id
            //     )
            //     .filter(Boolean),
            //   'id'
            // ));

            return (
              <div>
                <Stack
                  key={m.id || m?.message_id}
                  direction={isSender ? 'row-reverse' : 'row'}
                  spacing={1}
                  sx={{ mb: 3, alignItems: 'flex-end' }}
                >
                  {/* Avatar */}
                  <Avatar
                    sx={{
                      bgcolor: 'grey.500',
                      width: 32,
                      height: 32,
                      fontSize: 14,
                    }}
                  >
                    {m.msg_sender ? m.msg_sender : 'U'}
                  </Avatar>

                  {/* Message bubble */}
                  <Paper
                    elevation={1}
                    sx={{
                      px: 1.5,
                      py: 1,
                      maxWidth: '75%',
                      backgroundColor: isSender ? '#DCF8C6' : '#FFFFFF',
                      borderRadius: 3,
                      display: 'flex',
                      justifyContent: 'space-between',
                      gap: 1,
                    }}
                  >
                    {/* Text content */}
                    {m?.content && (
                      <Typography
                        variant='body1'
                        sx={{ whiteSpace: 'pre-line', fontSize: '0.8rem' }}
                      >
                        {compact([
                          m?.emcode,
                          m?.emaction,
                          m?.emlocation,
                          m?.content,
                        ])?.join(' - ')}
                      </Typography>
                    )}
                    {/* Time + read ticks */}
                    <Stack
                      direction='row'
                      justifyContent='flex-end'
                      spacing={0.5}
                      sx={{
                        mt: 0.3,
                        display: 'flex',
                        flex: 'none',
                        alignItems: 'flex-end',
                      }}
                    >
                      <Typography
                        variant='caption'
                        sx={{
                          color: 'text.secondary',
                          fontSize: '0.7rem',
                          display: 'flex',
                          alignItems: 'center',
                        }}
                      >
                        {m.created_at
                          ? moment(m?.created_at).format('h:mm A')
                          : ''}
                      </Typography>

                      {isSender && (
                        <Box
                          sx={{
                            ml: 0.5,
                            display: 'flex',
                            alignItems: 'center',
                          }}
                        >
                          {m.read_at ? (
                            <BsCheckAll color='#34B7F1' />
                          ) : (
                            <BsCheck color='gray' />
                          )}
                        </Box>
                      )}
                    </Stack>
                  </Paper>
                </Stack>
                {!isEmpty(m.attachment_url) &&
                  startsWith(m.attachment_url, '[') && (
                    <Box
                      sx={{
                        display: 'flex',
                        justifyContent: isSender ? 'flex-end' : 'flex-start',
                        // flexDirection: 'column',
                        flexWrap: 'wrap',
                        gap: 2, // spacing between images
                        mt: 0.5,
                        // bgcolor: '#f0f0f0',
                        p: 0.5,
                        pl: 5,
                        borderRadius: 2,
                      }}
                    >
                      {JSON.parse(m.attachment_url).map((img, idx) => (
                        <Box
                          key={idx}
                          component='img'
                          src={`${process.env.REACT_APP_IMAGE_URL}/images/${img}`}
                          alt='attachment'
                          sx={{
                            flex: '1 1 48%', // two images per row by default
                            maxWidth: '15%',
                            aspectRatio: '1/1', // square shape
                            objectFit: 'contain',
                            borderRadius: 2,
                            cursor: 'pointer',
                            boxShadow: '0 1px 2px rgba(0,0,0,0.1)',
                            padding: '0.5rem 1rem',
                            border: '4px solid #05A883',
                          }}
                          onClick={() => {
                            setImageUrl(img);
                            setShowImageModal(true);
                          }}
                        />
                      ))}
                    </Box>
                  )}
              </div>
            );
          })}

          <div ref={messagesEndRef} />
        </Box>
      )}
      {showImageModal && (
        <ImageModal
          open={showImageModal}
          handleClose={() => setShowImageModal(false)}
          imageUrl={imageURl}
        />
      )}
    </Box>
  );
};

export default ChatWindow;
